import styled from '@emotion/styled';

export const Title = styled.h1`
  font-size: 2.6rem;
  font-weight: normal;
  margin: 0 0 1.43rem;
`;

export const LookupActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 20px;
  border-top: ${({ withBorder }) => (withBorder ? '1px solid #ddd' : '0')};
`;

export const WarrantyActions = styled.div`
  display: flex;
  min-width: 200px;
  margin-left: 15px;
  flex-direction: column;
  align-items: center;

  .MuiButton-root {
    margin-bottom: 10px;
  }
`;
